mutation UpdateInboundSmsRules($input: InboundSmsRulesUpdateInput!) {
    inboundSmsRulesUpdate(input: $input) {
        assignment {
            assignedUser {
                id
                name
            }
        }
    }
}
